import React, { useState, useEffect } from "react";
import Select from "../../ui/PortalSelect";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import { Modal } from 'react-bootstrap'
import axios from 'axios';
import Swal from 'sweetalert2';
import { baseURL } from '../backend_url';
import { formatDate, formatDate_withTime } from '../commonFunctions';
import {
  buildAccessibleAccountOptions,
  deriveVendorAccountSelection,
  findAccessibleAccountById,
  getAccessibleAccountIdentity,
  getUserAccountType,
  loadAccessibleCompanies,
  readSessionUser,
} from '../accountAccess';
import { expectExactPayload, requestErrorMessage } from '../mutationContract';
import {
  APPLIES_ON_OPTIONS,
  RENTAL_PERIOD_OPTIONS,
  appliedTaxSummary,
  buildTaxCopyTargetOptions,
  buildTaxLocationOptions,
  normalizeAppliedTaxOptions,
  selectedOption,
  taxCopyVerificationRows,
  taxCopyVerifiedSummary,
  validateTaxCopyResponse,
} from './taxSetupPresentation';
import './TaxSetup.css';


export default function UpdateForm({ accessType }) {

  var temp_company_id = "";
  var temp_location_id = "";
  const [companyDetail, setcompanyDetail] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [company_id, setcompany_id] = useState("");
  const [locationDetail, setLocationDetail] = useState([{}]);
  const [locationName, setLocationName] = useState("");
  const [locationId, setLocationId] = useState("");
  const [lgShow1, setLgShow1] = useState(false);
  const [lgShow2, setLgShow2] = useState(false);
  const [lgShow3, setLgShow3] = useState(false);
  const [independentTaxName, setIndependentTaxName] = useState("");
  const [independentType, setIndependentType] = useState("");
  const [independentCurrency, setIndependentCurrency] = useState("");
  const [independentAmount, setIndependentAmount] = useState("");
  const [baseRateTaxName, setBaseRateTaxName] = useState("");
  const [baseRateType, setBaseRateType] = useState("Per Rental");
  const [baseRatePercentage, setBaseRatePercentage] = useState("");
  const [calculatedTaxName, setCalculatedTaxName] = useState("");
  const [calculatedPercentage, setCalculatedPercentage] = useState("");
  const [updateFlag1, setUpdateFlag1] = useState(false);
  const [updateFlag2, setUpdateFlag2] = useState(false);
  const [updateFlag3, setUpdateFlag3] = useState(false);
  const [independentTaxDetail, setIndependentTaxDetail] = useState([]);
  const [baseRateTaxDetail, setBaseRateTaxDetail] = useState([]);
  const [calculatedTaxDetail, setCalculatedTaxDetail] = useState([]);
  const [updateClicked1, setUpdateClicked1] = useState(false);
  const [updateClicked2, setUpdateClicked2] = useState(false);
  const [updateClicked3, setUpdateClicked3] = useState(false);
  const [selected, setSelected] = useState([]);
  const [allTaxesData, setAllTaxesData] = useState([]);
  const [loggedInUserDetail, setLoggedInUserDetail] = useState({});

  const [independentApplisOn, setIndependentAppliesOn] = useState("");
  const [baseRateApplisOn, setBaseRateAppliesOn] = useState("");
  const [calculatedApplisOn, setCalculatedAppliesOn] = useState("");

  const [taxNameDetail, setTaxNameDetail] = useState([]);
  const [copyTargetLocations, setCopyTargetLocations] = useState([]);
  const [copyInProgress, setCopyInProgress] = useState(false);
  const [accountSelectorDisabled, setAccountSelectorDisabled] = useState(false);
  const [copyResult, setCopyResult] = useState(null);
  const [taxLoadError, setTaxLoadError] = useState({});

  const updateTaxLoadError = (category, message = '') => {
    setTaxLoadError((current) => {
      const next = { ...current };
      if (message) next[category] = message;
      else delete next[category];
      return next;
    });
  };

  const handleMutationError = (error) => {
    console.error('Tax Setup request failed:', error)
    Swal.fire({
      position: 'center',
      icon: 'error',
      title: 'Request failed',
      text: requestErrorMessage(
        error,
        'The Tax Setup change could not be saved. Please try again.'
      )
    })
  }


  //API call
  useEffect(() => {
    let active = true;
    const { user: foundUser } = readSessionUser();
    if (!foundUser) {
      setcompanyDetail([]);
      return undefined;
    }

    setLoggedInUserDetail(foundUser);

    loadAccessibleCompanies(baseURL, foundUser, 'Tax_Account Access')
      .then((accounts) => {
        if (!active) return;

        const selection = deriveVendorAccountSelection(accounts, foundUser);
        setcompanyDetail(selection.accounts);
        setAccountSelectorDisabled(selection.isSelectorDisabled);
        if (selection.shouldAutoSelect && selection.selectedAccountName) {
          setcompany_id(selection.selectedAccountId);
          setCompanyName(selection.selectedAccountName);
        }
      })
      .catch(() => {
        if (active) {
          setcompanyDetail([]);
          setAccountSelectorDisabled(false);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  //Trigger on Company Name Dropdown Changes , getting Company ID
  useEffect(() => {

    if (companyDetail && company_id) {

      setIndependentCurrency("");
      setLocationDetail([]);
      setIndependentTaxDetail([]);
      setBaseRateTaxDetail([]);
      setCalculatedTaxDetail([]);
      setLocationName("");
      setLocationId("");
      setIndependentAppliesOn("");
      setBaseRateAppliesOn("");
      setCalculatedAppliesOn("");
      setCopyTargetLocations([]);
      setCopyResult(null);
      setTaxLoadError({});

      const obj_company_detail = findAccessibleAccountById(companyDetail, company_id);
      if (!obj_company_detail) return;

      const selectedCompany = getAccessibleAccountIdentity(obj_company_detail);
      const temp_company_id = selectedCompany.id;

      let company_type = obj_company_detail.account_type;
      setCompanyName(selectedCompany.name);

      // axios.get(baseURL + "/get_company_location/" + temp_company_id)
      //   .then((res) => {
      //     setLocationDetail(allTemp);
      //     setIndependentTaxDetail([]);
      //     setLocationName("");
      //     setLocationId("");

      //   }).catch((e) => {

      //   });

      //API call for getting data from DB
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      };

      fetch(
        baseURL + "/get_company_location/" + temp_company_id
        + '?companyNumber=' + encodeURIComponent(temp_company_id.toString()),
        requestOptions
      )
        .then((res) => res.json())
        .then((data) => {

          let allTemp = data.res;


          if (loggedInUserDetail.role_capabilities?.all_modules_access === true) {
            if (allTemp.length > 0) {
              setLocationDetail(allTemp);
              setIndependentTaxDetail([]);
              setBaseRateTaxDetail([]);
              setCalculatedTaxDetail([]);
              setLocationName("");
              setLocationId("");
            }
          }
          else if (company_type === 'Affiliate' && getUserAccountType(loggedInUserDetail) === 'Corporate') {

            if (allTemp.length > 0) {
              setLocationDetail(allTemp);
              setIndependentTaxDetail([]);
              setBaseRateTaxDetail([]);
              setCalculatedTaxDetail([]);
              setLocationName("");
              setLocationId("");
            }
          }
          else {
            axios.post(baseURL + "/get_individual_user_details", {
              'user_email': loggedInUserDetail.userEmail,
              'companyNumber': temp_company_id.toString()
            })
              .then((data) => {
                if (allTemp.length > 0) {

                  allTemp = allTemp.filter((val) => val !== undefined && data.data[0].location_allocated[val.location_id]);

                  setLocationDetail(allTemp);
                  setIndependentTaxDetail([]);
                  setBaseRateTaxDetail([]);
                  setCalculatedTaxDetail([]);
                  setLocationName("");
                  setLocationId("");

                }

              }
              )
          }
        });



    }
  }, [company_id]);

  useEffect(() => {
    if (locationName && locationDetail) {

      setIndependentTaxName("");
      setIndependentType("");
      setIndependentCurrency("");
      setIndependentAmount("");
      setIndependentTaxDetail([]);
      setBaseRatePercentage("");
      setBaseRateType("");
      setBaseRateTaxName("");
      setBaseRateTaxDetail([]);
      setCalculatedTaxName("");
      setCalculatedPercentage("");
      setCalculatedTaxDetail([]);
      setIndependentAppliesOn("");
      setBaseRateAppliesOn("");
      setCalculatedAppliesOn("");
      setCopyTargetLocations([]);
      setCopyResult(null);
      setTaxLoadError({});

      const selectedLocation = locationDetail.find((loc) => (
        String(loc.location_id ?? loc._id ?? '').trim() === String(locationName).trim()
      ));
      temp_location_id = String(selectedLocation?.location_id ?? selectedLocation?._id ?? '').trim();
      if (!temp_location_id) return;
      setLocationId(temp_location_id);

      const id = temp_location_id.toString() + "||" + "calculated";
      //api to store data in tax collection of db
      axios.get(
        baseURL + "/get_tax_setup/" + id
        + '?companyNumber=' + encodeURIComponent(company_id.toString())
      ).then((res) => {

        updateTaxLoadError('calculated');

        setCalculatedTaxDetail(res.data.res);
        //geting all taxes starts
        const allTaxTemp = res.data.all_taxes;
        let tempArr = [];
        tempArr.push({ 'value': 'Base Rate', 'label': 'Base Rate' });
        if (allTaxTemp.length > 0) {
          for (let i = 0; i < allTaxTemp.length; i++) {
            tempArr.push({ 'value': allTaxTemp[i].tax_name, 'label': allTaxTemp[i].tax_name });
          }
        }
        setAllTaxesData(tempArr);
        //geting all taxes ends
      }).catch(() => {
        updateTaxLoadError(
          'calculated',
          'Compound Taxes could not be loaded. Please retry or select the location again.'
        );
      });



      axios.get(
        baseURL + "/get_location_details/" + temp_location_id
        + '?companyNumber=' + encodeURIComponent(company_id.toString())
      )
        .then((res) => {

          setIndependentCurrency(res.data.item.currency);
          setUpdateFlag1(!updateFlag1);
          setUpdateFlag2(!updateFlag2);
          setUpdateFlag3(!updateFlag3);


        }).catch((e) => {

        });
      
      axios.get(
        baseURL + "/get_optional_services_standard/" + company_id.toString()
        + '?companyNumber=' + encodeURIComponent(company_id.toString())
      )
        .then((res) => {
          setTaxNameDetail(res.data);
        });
    }
  }, [locationName])

  //Option for company name
  const companyNameOptions = buildAccessibleAccountOptions(companyDetail);

  const handleInputChangeCompanyName = characterEntered => {
    const selectedCompany = findAccessibleAccountById(
      companyDetail,
      characterEntered?.value
    );
    const selectedIdentity = getAccessibleAccountIdentity(selectedCompany);
    setcompany_id(selectedIdentity.id);
    setCompanyName(selectedIdentity.name);
  };

  //Option for Tax name
  const TaxNameOptions = taxNameDetail.filter((val) => val.extraTypeFor === 'Tax').map((value) => (

    { value: value.extraCategory, label: value.extraCategory }
  ));

  const handleInputChangeIndependentTaxName = characterEntered => {
    setIndependentTaxName(characterEntered.value);
  };
  const handleInputChangeBaseRateTaxName = characterEntered => {
    setBaseRateTaxName(characterEntered.value);
  };
  const handleInputChangeCalculatedTaxName = characterEntered => {
    setCalculatedTaxName(characterEntered.value);
  };


  //Option for Location name
  const locationNameOptions = buildTaxLocationOptions(locationDetail);

  const handleInputChangeLocationName = characterEntered => {
    setLocationName(characterEntered.value);
  };

  const copyTargetLocationOptions = buildTaxCopyTargetOptions(
    locationDetail,
    locationId
  );
  const copyVerificationRows = taxCopyVerificationRows(copyResult);

  const copiedLocationLabel = (targetLocationId) => (
    buildTaxLocationOptions(locationDetail)
      .find((option) => option.value === targetLocationId)?.label || targetLocationId
  );

  const handleViewCopiedLocation = (targetLocationId) => {
    setLocationName(targetLocationId);
    window.setTimeout(() => {
      document.getElementById('tax-setup-fees-section')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }, 0);
  };

  const handleCopyTaxStructure = async () => {
    if (!company_id || !locationId) {
      Swal.fire('Please select an account and source location first');
      return;
    }
    if (copyTargetLocations.length === 0) {
      Swal.fire('Please select at least one destination location');
      return;
    }

    const confirmation = await Swal.fire({
      title: 'Replace destination tax structures?',
      text: `Replace mode will make ${copyTargetLocations.length} selected destination location${copyTargetLocations.length === 1 ? '' : 's'} an exact tax-configuration copy of the source. Full values will be copied, matching taxes updated, and missing taxes added. Warning: every destination-only tax will be removed and recorded in the audit history.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Replace taxes',
      confirmButtonColor: '#c2410c',
    });
    if (!confirmation.isConfirmed) return;

    setCopyInProgress(true);
    setCopyResult(null);
    const requestedTargetIds = copyTargetLocations.map((option) => option.value);
    const requestedTargetLabels = copyTargetLocations.map((option) => option.label);
    const sourceLabel = copiedLocationLabel(locationId);
    try {
      const response = await axios.post(baseURL + '/copy_tax_structure', {
        companyNumber: company_id.toString(),
        account_id: company_id.toString(),
        source_location_id: locationId.toString(),
        target_location_ids: requestedTargetIds,
        updated_by: loggedInUserDetail.userEmail,
      });
      const validation = validateTaxCopyResponse(response.data, requestedTargetIds);
      if (!validation.valid) {
        throw new Error(validation.message);
      }

      setCopyTargetLocations([]);
      setCopyResult(response.data);
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Exact tax copy (Xerox) verified',
        text: taxCopyVerifiedSummary(
          response.data,
          sourceLabel,
          requestedTargetLabels
        ),
      });
    } catch (error) {
      setCopyResult(null);
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Exact tax copy not confirmed',
        text: `${requestErrorMessage(error, 'The server could not verify the exact tax copy.')} No success was recorded because an exact copy was not confirmed.`,
      });
    } finally {
      setCopyInProgress(false);
    }
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();

    if (companyName === "") {
      Swal.fire('Please select an account to proceed ahead');
      return;
    }
    if (locationName === "") {
      Swal.fire('Please select a location to proceed ahead');
      return;
    }

    if (independentTaxName.toString().trim() === "") {
      Swal.fire('Please enter tax name to proceed ahead');
      return;
    }
    if (independentType.toString().trim() === "") {
      Swal.fire('Please select Per Day or Per Rental option to proceed ahead');
      return;
    }
    if (independentCurrency.toString().trim() === "") {
      Swal.fire('Currency can\'t be enpty');
      return;
    }
    if (independentAmount.toString().trim() === "") {
      Swal.fire('Please enter amount to proceed ahead');
      return;
    }

    if (isNaN(independentAmount)) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please enter number in amount field',
        showConfirmButton: false,
        timer: 3000
      })
      setIndependentAmount("");
      return;
    }

    if (independentApplisOn === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an option of Applies On field',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }

    Swal.fire({
      title: 'Do you want to add this tax ?',

      showCancelButton: true,
      confirmButtonText: 'Yes',


    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        const requestBody = {
          '_id': locationId + "-" + independentTaxName.toString().trim() + "-" + "independent",
          'tax_name': independentTaxName.toString().trim(),
          'location_id': locationId.toString(),
          'account_id': company_id.toString(),
          'companyNumber': company_id.toString(),
          'tax_type': 'independent',
          'currency': independentCurrency,
          'per_day_per_rental': independentType,
          'amount': independentAmount,
          'applies_on': independentApplisOn,
          'created_date': new Date(),
          'updated_date': new Date(),
          'created_by': loggedInUserDetail.userEmail,
          'updated_by': loggedInUserDetail.userEmail
        }
        //api to store data in tax collection of db
        axios.post(baseURL + "/save_tax_setup", requestBody).then((res) => {
          expectExactPayload(res.data, 'success', 'Independent Tax save');

          setLgShow1(false);
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Tax saved successfully',
            showConfirmButton: false,
            timer: 3000
          })
          setUpdateFlag1(!updateFlag1);
          setIndependentTaxName("");
          setIndependentType("");
          setIndependentAmount("");
        }).catch(handleMutationError)

      }
    })



  }

  const handleSubmit2 = (e) => {
    e.preventDefault();
    if (companyName == "") {
      Swal.fire('Please select an account to proceed ahead');
      return;
    }
    if (locationName == "") {
      Swal.fire('Please select a location to proceed ahead');
      return;
    }

    if (baseRateTaxName.toString().trim() == "") {
      Swal.fire('Please enter tax name to proceed ahead');
      return;
    }
    if (baseRateType.toString().trim() == "") {
      Swal.fire('Please select Per Day or Per Rental option to proceed ahead');
      return;
    }
    if (baseRatePercentage.toString().trim() == "") {
      Swal.fire('Please enter percentage to proceed ahead');
      return;
    }
    if (isNaN(baseRatePercentage)) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please enter number in amount field',
        showConfirmButton: false,
        timer: 3000
      })
      setBaseRatePercentage("");
      return;
    }
    if (baseRateApplisOn === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an option of Applies On field',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }

    Swal.fire({
      title: 'Do you want to add this tax ?',

      showCancelButton: true,
      confirmButtonText: 'Yes',


    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        const requestBody = {
          '_id': locationId + "-" + baseRateTaxName.toString().trim() + "-" + "baserate",
          'tax_name': baseRateTaxName.toString().trim(),
          'location_id': locationId.toString(),
          'account_id': company_id.toString(),
          'companyNumber': company_id.toString(),
          'tax_type': 'baserate',
          'per_day_per_rental': baseRateType,
          'percentage': baseRatePercentage,
          'applies_on': baseRateApplisOn,
          'created_date': new Date(),
          'updated_date': new Date(),
          'created_by': loggedInUserDetail.userEmail,
          'updated_by': loggedInUserDetail.userEmail
        }
        //api to store data in tax collection of db
        axios.post(baseURL + "/save_tax_setup", requestBody).then((res) => {
          expectExactPayload(res.data, 'success', 'Base Rate Tax save');

          setLgShow2(false);
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Tax saved successfully',
            showConfirmButton: false,
            timer: 3000
          })
          setUpdateFlag2(!updateFlag2);
          setBaseRateTaxName("");
          setBaseRateType("Per Rental");
          setBaseRatePercentage("");
        }).catch(handleMutationError)
      }
    })

  }

  //handle submit Calculated Tax start
  const handleSubmit3 = (e) => {

    e.preventDefault();
    if (companyName == "") {
      Swal.fire('Please select an account to proceed ahead');
      return;
    }
    if (locationName == "") {
      Swal.fire('Please select a location to proceed ahead');
      return;
    }

    if (calculatedTaxName.toString().trim() == "") {
      Swal.fire('Please enter tax name to proceed ahead');
      return;
    }

    if (calculatedPercentage.toString().trim() == "") {
      Swal.fire('Please enter percentage to proceed ahead');
      return;
    }
    if (selected.length === 0) {
      Swal.fire('Please select applied taxes to proceed ahead');
      return;
    }
    if (isNaN(calculatedPercentage)) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please enter number in amount field',
        showConfirmButton: false,
        timer: 3000
      })
      setCalculatedPercentage("");
      return;
    }
    if (calculatedApplisOn === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an option of Applies On field',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }

    Swal.fire({
      title: 'Do you want to add this tax ?',

      showCancelButton: true,
      confirmButtonText: 'Yes',


    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        const requestBody = {
          '_id': locationId + "-" + calculatedTaxName.toString().trim() + "-" + "calculated",
          'tax_name': calculatedTaxName.toString().trim(),
          'location_id': locationId.toString(),
          'account_id': company_id.toString(),
          'companyNumber': company_id.toString(),
          'tax_type': 'calculated',
          'percentage': calculatedPercentage,
          'applied_taxes': selected,
          'applies_on': calculatedApplisOn,
          'created_date': new Date(),
          'updated_date': new Date(),
          'created_by': loggedInUserDetail.userEmail,
          'updated_by': loggedInUserDetail.userEmail
        }
        //api to store data in tax collection of db
        axios.post(baseURL + "/save_tax_setup", requestBody).then((res) => {
          expectExactPayload(res.data, 'success', 'Calculated Tax save');

          setLgShow3(false);
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Tax saved successfully',
            showConfirmButton: false,
            timer: 3000
          })
          setUpdateFlag3(!updateFlag3);
          setCalculatedTaxName("");
          setCalculatedPercentage("");
          setSelected([]);
        }).catch(handleMutationError)
      }
    })

  }//handle submit Calculated Tax ends

  //Validation for only number value in amount field
  useEffect(() => {
    if (isNaN(independentAmount) || isNaN(baseRatePercentage) || isNaN(calculatedPercentage)
      || independentAmount < 0 || baseRatePercentage < 0 || calculatedPercentage < 0) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please enter number in amount field',
        showConfirmButton: false,
        timer: 3000
      })

      setIndependentAmount("");
      setBaseRatePercentage("");
      setCalculatedPercentage("");
    }

  }, [independentAmount, baseRatePercentage, calculatedPercentage])



  //Updating Fee -> Table 1 current instance from db
  useEffect(() => {
    if (!locationId || !company_id) {
      return undefined;
    }

    let active = true;
    const id = locationId.toString() + "||" + "independent";
    //api to store data in tax collection of db
    axios.get(
      baseURL + "/get_tax_setup/" + id
      + '?companyNumber=' + encodeURIComponent(company_id.toString())
      + '&_=' + Date.now()
    ).then((res) => {
      if (!active) return;
      updateTaxLoadError('independent');

      setIndependentTaxDetail(res.data.res);
      //geting all taxes starts
      const allTaxTemp = res.data.all_taxes;
      let tempArr = [];
      if (allTaxTemp.length > 0) {

        tempArr.push({ 'value': 'Base Rate', 'label': 'Base Rate' });
        for (let i = 0; i < allTaxTemp.length; i++) {
          tempArr.push({ 'value': allTaxTemp[i].tax_name, 'label': allTaxTemp[i].tax_name });
        }

      }

      setAllTaxesData(tempArr);
      setIndependentAppliesOn("");
      //geting all taxes ends
    }).catch(() => {
      if (active) {
        updateTaxLoadError(
          'independent',
          'Fees could not be loaded. Please retry or select the location again.'
        );
      }
    });

    return () => {
      active = false;
    };
  }, [updateFlag1, locationId, company_id])

  //Updating State Tax -> Table 2 current instance from db
  useEffect(() => {
    if (!locationId || !company_id) {
      return undefined;
    }

    let active = true;
    const id = locationId.toString() + "||" + "baserate";
    //api to store data in tax collection of db
    axios.get(
      baseURL + "/get_tax_setup/" + id
      + '?companyNumber=' + encodeURIComponent(company_id.toString())
      + '&_=' + Date.now()
    ).then((res) => {
      if (!active) return;
      updateTaxLoadError('baserate');

      setBaseRateTaxDetail(res.data.res);

      //geting all taxes starts
      const allTaxTemp = res.data.all_taxes;
      let tempArr = [];
      if (allTaxTemp.length > 0) {

        tempArr.push({ 'value': 'Base Rate', 'label': 'Base Rate' });
        for (let i = 0; i < allTaxTemp.length; i++) {
          tempArr.push({ 'value': allTaxTemp[i].tax_name, 'label': allTaxTemp[i].tax_name });
        }

      }
      setAllTaxesData(tempArr);
      setBaseRateAppliesOn("");
      //geting all taxes ends

    }).catch(() => {
      if (active) {
        updateTaxLoadError(
          'baserate',
          'State Taxes could not be loaded. Please retry or select the location again.'
        );
      }
    });

    return () => {
      active = false;
    };
  }, [updateFlag2, locationId, company_id])

  //Updating Compound Tax -> Table 3 current instance from db
  useEffect(() => {
    if (!locationId || !company_id) {
      return undefined;
    }

    let active = true;
    const id = locationId.toString() + "||" + "calculated";
    //api to store data in tax collection of db
    axios.get(
      baseURL + "/get_tax_setup/" + id
      + '?companyNumber=' + encodeURIComponent(company_id.toString())
      + '&_=' + Date.now()
    ).then((res) => {
      if (!active) return;
      updateTaxLoadError('calculated');

      setCalculatedTaxDetail(res.data.res);
      //geting all taxes starts
      const allTaxTemp = res.data.all_taxes;
      let tempArr = [];
      tempArr.push({ 'value': 'Base Rate', 'label': 'Base Rate' });
      if (allTaxTemp.length > 0) {
        for (let i = 0; i < allTaxTemp.length; i++) {
          tempArr.push({ 'value': allTaxTemp[i].tax_name, 'label': allTaxTemp[i].tax_name });
        }
      }
      setAllTaxesData(tempArr);
      setCalculatedAppliesOn("");
      //geting all taxes ends
    }).catch(() => {
      if (active) {
        updateTaxLoadError(
          'calculated',
          'Compound Taxes could not be loaded. Please retry or select the location again.'
        );
      }
    });

    return () => {
      active = false;
    };
  }, [updateFlag3, locationId, company_id])


  //Handle Delete Independent Tax
  const handleDelete1 = (id) => {
    Swal.fire({
      title: 'Do you want to delete this tax ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {

        axios.post(baseURL + "/delete_tax_setup", {
          "_id": id,
          "account_id": company_id.toString(),
          "companyNumber": company_id.toString(),
          "location_id": locationId.toString(),
          "updated_date": new Date(),
          "updated_by": loggedInUserDetail.userEmail
        })
          .then((res1) => {
            expectExactPayload(res1.data, 'success', 'Independent Tax delete');
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Tax deleted successfully',
              showConfirmButton: false,
              timer: 3000
            })
            setUpdateFlag1(!updateFlag1)
          }).catch(handleMutationError);


      }
    })
  }

  //Handle Delete Base Rate Tax
  const handleDelete2 = (id) => {
    Swal.fire({
      title: 'Do you want to delete this tax ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {

        axios.post(baseURL + "/delete_tax_setup", {
          "_id": id,
          "account_id": company_id.toString(),
          "companyNumber": company_id.toString(),
          "location_id": locationId.toString(),
          "updated_date": new Date(),
          "updated_by": loggedInUserDetail.userEmail
        })
          .then((res1) => {
            expectExactPayload(res1.data, 'success', 'Base Rate Tax delete');
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Tax deleted successfully',
              showConfirmButton: false,
              timer: 3000
            })
            setUpdateFlag2(!updateFlag2)

          }).catch(handleMutationError);


      }
    })
  }

  //Handle Delete Calculated Tax
  const handleDelete3 = (id) => {
    Swal.fire({
      title: 'Do you want to delete this tax ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {


        axios.post(baseURL + "/delete_tax_setup", {
          "_id": id,
          "account_id": company_id.toString(),
          "companyNumber": company_id.toString(),
          "location_id": locationId.toString(),
          "updated_date": new Date(),
          "updated_by": loggedInUserDetail.userEmail
        })
          .then((res1) => {
            expectExactPayload(res1.data, 'success', 'Calculated Tax delete');
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Tax deleted successfully',
              showConfirmButton: false,
              timer: 3000
            })
            setUpdateFlag3(!updateFlag3)
          }).catch(handleMutationError);


      }
    })
  }

  //Handle Update Independent Tax
  const handleUpdateDB1 = (e) => {

    e.preventDefault();
    if (companyName == "") {
      Swal.fire('Please select an account to proceed ahead');
      return;
    }
    if (locationName == "") {
      Swal.fire('Please select a location to proceed ahead');
      return;
    }

    if (independentTaxName.toString().trim() == "") {
      Swal.fire('Please enter tax name to proceed ahead');
      return;
    }
    if (independentType == "") {
      Swal.fire('Please select Per Day or Per Rental option to proceed ahead');
      return;
    }
    if (independentCurrency == "") {
      Swal.fire('Currency can\'t be enpty');
      return;
    }
    if (independentAmount.toString().trim() == "") {
      Swal.fire('Please enter amount to proceed ahead');
      return;
    }
    if (independentApplisOn === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an option of Applies On field',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }

    const id = locationId + "-" + independentTaxName + "-" + "independent";
    Swal.fire({
      title: 'Do you want to save these changes ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {

        axios.put(baseURL + "/update_tax_setup/" + id, {
          'account_id': company_id.toString(),
          'companyNumber': company_id.toString(),
          'location_id': locationId.toString(),
          'per_day_per_rental': independentType,
          'amount': independentAmount,
          'applies_on': independentApplisOn,
          'updated_by': loggedInUserDetail.userEmail,
          'updated_date': new Date(),
        })
          .then((res1) => {
            expectExactPayload(res1.data, 'success', 'Independent Tax update');

            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Tax Updated Successfully',
              showConfirmButton: false,
              timer: 3000
            })
            setLgShow1(false);
            setUpdateFlag1(!updateFlag1);
          }).catch(handleMutationError);


      }
    })
  }
  //Handle Update Base Rate Tax
  const handleUpdateDB2 = (e) => {

    e.preventDefault();
    if (companyName == "") {
      Swal.fire('Please select an account to proceed ahead');
      return;
    }
    if (locationName == "") {
      Swal.fire('Please select a location to proceed ahead');
      return;
    }

    if (baseRateTaxName.toString().trim() == "") {
      Swal.fire('Please enter tax name to proceed ahead');
      return;
    }
    if (baseRateType == "") {
      Swal.fire('Please select Per Day or Per Rental option to proceed ahead');
      return;
    }
    if (baseRatePercentage.toString().trim() == "") {
      Swal.fire('Please enter percentage to proceed ahead');
      return;
    }
    if (baseRateApplisOn === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an option of Applies On field',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    const id = locationId + "-" + baseRateTaxName + "-" + "baserate";
    Swal.fire({
      title: 'Do you want to save these changes ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {

        axios.put(baseURL + "/update_tax_setup/" + id, {
          'account_id': company_id.toString(),
          'companyNumber': company_id.toString(),
          'location_id': locationId.toString(),
          'per_day_per_rental': baseRateType,
          'percentage': baseRatePercentage,
          'applies_on': baseRateApplisOn,
          'updated_by': loggedInUserDetail.userEmail,
          'updated_date': new Date(),
        })
          .then((res1) => {
            expectExactPayload(res1.data, 'success', 'Base Rate Tax update');
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Tax Updated Successfully',
              showConfirmButton: false,
              timer: 3000
            })
            setLgShow2(false);
            setUpdateFlag2(!updateFlag2);
          }).catch(handleMutationError);


      }
    })
  }
  //Handle Update Calculated Tax
  const handleUpdateDB3 = (e) => {
    e.preventDefault();
    if (companyName == "") {
      Swal.fire('Please select an account to proceed ahead');
      return;
    }
    if (locationName == "") {
      Swal.fire('Please select a location to proceed ahead');
      return;
    }

    if (calculatedTaxName.toString().trim() == "") {
      Swal.fire('Please enter tax name to proceed ahead');
      return;
    }

    if (calculatedPercentage.toString().trim() == "") {
      Swal.fire('Please enter percentage to proceed ahead');
      return;
    }
    if (selected.length === 0) {
      Swal.fire('Please select applied taxes to proceed ahead');
      return;
    }
    if (calculatedApplisOn === '') {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: 'Please select an option of Applies On field',
        showConfirmButton: false,
        timer: 3000
      })
      return;
    }
    const id = locationId + "-" + calculatedTaxName + "-" + "calculated";
    Swal.fire({
      title: 'Do you want to save these changes ?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
    }).then((result) => {
      if (result.isConfirmed) {

        axios.put(baseURL + "/update_tax_setup/" + id, {
          'account_id': company_id.toString(),
          'companyNumber': company_id.toString(),
          'location_id': locationId.toString(),
          'applied_taxes': selected,
          'percentage': calculatedPercentage,
          'applies_on': calculatedApplisOn,
          'updated_by': loggedInUserDetail.userEmail,
          'updated_date': new Date(),
        })
          .then((res1) => {
            expectExactPayload(res1.data, 'success', 'Calculated Tax update');
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'Tax Updated Successfully',
              showConfirmButton: false,
              timer: 3000
            })
            setLgShow3(false);
            setUpdateFlag3(!updateFlag3);
          }).catch(handleMutationError);


      }
    })
  }

  //Handle Update Independent Tax
  const handleUpdate1 = (val) => {

    setIndependentTaxName(val.tax_name);
    setIndependentAmount(val.amount);
    setIndependentCurrency(val.currency);
    setIndependentType(val.per_day_per_rental);
    setIndependentAppliesOn(val.applies_on)

    setLgShow1(true);
    setUpdateClicked1(true);
  }

  //Handle Update Base Rate Tax
  const handleUpdate2 = (val) => {

    setBaseRateTaxName(val.tax_name);
    setBaseRateType(val.per_day_per_rental);
    setBaseRatePercentage(val.percentage);
    setBaseRateAppliesOn(val.applies_on)


    setLgShow2(true);
    setUpdateClicked2(true);
  }
  //Handle Update Base Rate Tax
  const handleUpdate3 = (val) => {

    setCalculatedTaxName(val.tax_name);
    setCalculatedPercentage(val.percentage);
    setSelected(normalizeAppliedTaxOptions(val.applied_taxes));
    setCalculatedAppliesOn(val.applies_on)

    setLgShow3(true);
    setUpdateClicked3(true);
  }

  useEffect(() => {

    if (lgShow1 === false) {
      setUpdateClicked1(false);
    }
    if (updateClicked1 === false) {
      setIndependentTaxName("");
      setIndependentAmount("");
      setIndependentType("");
    }
  }, [lgShow1])

  useEffect(() => {

    if (lgShow2 === false) {
      setUpdateClicked2(false);
    }
    if (updateClicked2 === false) {
      setBaseRateTaxName("");
      setBaseRatePercentage("");
      setBaseRateType("Per Rental");
    }
  }, [lgShow2])

  useEffect(() => {

    if (lgShow3 === false) {
      setUpdateClicked3(false);
    }
    if (updateClicked3 === false) {
      setCalculatedTaxName("");
      setCalculatedPercentage("");
      setSelected([]);
    }
  }, [lgShow3])


  return (
    <div className="tax-setup-workspace">
      <div className="row pt-2">
        <div className="col-12 px-3 tax-setup-intro">
          <span className="tax-setup-intro__text">

            {accessType === "View" ? "Select account and location to view tax: " : "Select account and location to proceed ahead: "}

          </span>
        </div>
      </div>

      <div className="row pt-5">
        {/* <div className="col-1"></div> */}
        <div className="col-12 px-3 tax-setup-content">
          <div className="tax-setup-context-card">
            <div className="tax-setup-context-grid">
              <div className="tax-setup-field">
                <label htmlFor="company_name" className="form-label">Account Name</label>
                <Select
                  value={selectedOption(companyNameOptions, company_id)}
                  inputId="company_name"
                  name="company_name"
                  options={companyNameOptions}
                  onChange={handleInputChangeCompanyName}
                  placeholder="Select Account Name"
                  isDisabled={accountSelectorDisabled}
                />
              </div>

              <div className="tax-setup-field">
                <label htmlFor="location_name" className="form-label">Location Name</label>
                <Select
                  value={selectedOption(locationNameOptions, locationName)}
                  inputId="location_name"
                  name="location_name"
                  options={locationNameOptions}
                  onChange={handleInputChangeLocationName}
                  placeholder="Select Location Name"
                  isDisabled={!companyName}
                  noOptionsMessage={() => (
                    companyName ? 'No locations available' : 'Select an account first'
                  )}
                />
              </div>
            </div>
          </div>

          {locationName && accessType !== 'View' && (
            <section className="tax-setup-copy-card" aria-labelledby="tax-copy-title">
              <div className="tax-setup-copy-card__intro">
                <span className="tax-setup-copy-card__eyebrow">Replace mode</span>
                <h5 id="tax-copy-title">Replace tax structure from a source</h5>
                <p>
                  Make each selected destination an exact tax-configuration
                  clone of this source location within the same account.
                </p>
                <ul className="tax-setup-copy-card__rules">
                  <li>Same tax name: update the destination tax.</li>
                  <li>Missing tax name: add it to the destination.</li>
                  <li className="tax-setup-copy-card__warning">
                    Destination-only tax: remove it and create a deletion audit.
                  </li>
                </ul>
              </div>

              <div className="tax-setup-copy-card__controls">
                <div className="tax-setup-field">
                  <label htmlFor="tax_copy_targets" className="form-label">
                    Destination Locations
                  </label>
                  <Select
                    className="tax-setup-select tax-setup-select--multi"
                    classNamePrefix="tax-setup-select"
                    value={copyTargetLocations}
                    inputId="tax_copy_targets"
                    name="tax_copy_targets"
                    options={copyTargetLocationOptions}
                    onChange={(options) => setCopyTargetLocations(options || [])}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isDisabled={copyInProgress || copyTargetLocationOptions.length === 0}
                    placeholder={copyTargetLocationOptions.length > 0
                      ? 'Select one or more locations'
                      : 'No other locations in this account'}
                    noOptionsMessage={() => 'No other locations in this account'}
                  />
                </div>

                <button
                  type="button"
                  className="btn btn-warning tax-setup-copy-card__button"
                  onClick={handleCopyTaxStructure}
                  disabled={copyInProgress || copyTargetLocations.length === 0}
                >
                  {copyInProgress ? 'Replacing...' : 'Replace taxes'}
                </button>
              </div>

              {copyVerificationRows.length > 0 && (
                <div className="tax-copy-verification" role="status" aria-live="polite">
                  <div className="tax-copy-verification__heading">
                    <div>
                      <span className="tax-copy-verification__eyebrow">Copy verification</span>
                      <h6>Destination tax structures verified</h6>
                    </div>
                    <p>
                      Taxes are displayed in three separate tables below. The category
                      counts add up to the verified total for each destination.
                    </p>
                  </div>
                  <div className="tax-copy-verification__grid">
                    {copyVerificationRows.map((verification) => (
                      <article
                        className={`tax-copy-verification__item ${verification.verified ? 'is-verified' : 'needs-review'}`}
                        key={verification.targetLocationId}
                      >
                        <div className="tax-copy-verification__item-header">
                          <strong>{copiedLocationLabel(verification.targetLocationId)}</strong>
                          <span>{verification.verificationLabel}</span>
                        </div>
                        <div className="tax-copy-verification__counts">
                          <span><b>{verification.counts.independent}</b> Fees</span>
                          <span><b>{verification.counts.baserate}</b> State Taxes</span>
                          <span><b>{verification.counts.calculated}</b> Compound Taxes</span>
                        </div>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-primary"
                          onClick={() => handleViewCopiedLocation(verification.targetLocationId)}
                        >
                          View destination
                        </button>
                      </article>
                    ))}
                  </div>
                </div>
              )}
            </section>
          )}
          {/* Second Row */}

          {Object.keys(taxLoadError).length > 0 && (
            <div className="alert alert-danger tax-setup-load-error" role="alert">
              <strong>Some tax details could not be loaded.</strong>
              <ul>
                {Object.entries(taxLoadError).map(([category, message]) => (
                  <li key={category}>{message}</li>
                ))}
              </ul>
            </div>
          )}

          {locationName ? (<>
            {/* existing Tax table 1 starts */}
            <div className="row pt-4" id="tax-setup-fees-section">
              <div className="col-md-12 tax-setup-section-card">
                <h5 className=" mb-3">Fees</h5>

                <div className="tax-setup-table-region" role="region" aria-label="Fees" tabIndex="0">
                <table className={`table tax-setup-data-table tax-setup-data-table--fees ${accessType === 'View' ? '' : 'tax-setup-data-table--editable'}`}>
                  <thead>
                    <tr>
                      <th scope="col">Tax Name</th>
                      <th scope="col">Per Day / Per Rental</th>
                      <th scope="col">Currency</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Applies On</th>
                      <th scope="col">Last Updated By</th>
                      <th scope="col">Last Updated Date</th>
                      {!(accessType === "View") &&
                        <>
                          <th scope="col">Edit</th>
                          <th scope="col">Delete</th>
                        </>
                      }

                    </tr>
                  </thead>
                  <tbody>
                    {independentTaxDetail.length > 0 ? independentTaxDetail.map((val) => (
                      <tr key={val._id}>
                        <td>{val.tax_name}</td>
                        <td>{val.per_day_per_rental}</td>
                        <td>{val.currency}</td>
                        <td>{val.amount}</td>
                        <td>{val.applies_on}</td>
                        <td>{val.updated_by}</td>
                        <td>{formatDate_withTime(new Date(val.updated_date))}</td>
                        {
                          !(accessType === "View") &&
                          <>
                            <td>
                              <button
                                type="button"
                                className="tax-setup-icon-button"
                                onClick={() => handleUpdate1(val)}
                                aria-label={`Edit ${val.tax_name}`}
                                title="Edit tax"
                              >
                                <EditIcon fontSize="small" />
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="tax-setup-icon-button tax-setup-icon-button--danger"
                                onClick={() => handleDelete1(val._id)}
                                aria-label={`Delete ${val.tax_name}`}
                                title="Delete tax"
                              >
                                <DeleteForeverIcon fontSize="small" />
                              </button>
                            </td>

                          </>
                        }
                      </tr>
                    )) : (
                      <tr>
                        <td colSpan="8">No tax present for selected location</td>
                      </tr>
                    )}


                  </tbody>
                </table>
                </div>
                {!(accessType === "View") && <button type="button" className="btn btn-success" onClick={() => setLgShow1(true)} >
                  Add New
                </button>}
                <Modal
                  size="lg"
                  show={lgShow1}
                  onHide={() => setLgShow1(false)}
                  aria-labelledby="fees-tax-modal-title"
                  dialogClassName="tax-setup-modal"
                >
                  <Modal.Header closeButton >
                    <Modal.Title id="fees-tax-modal-title" >
                      Fees
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    <form className="tax-setup-modal-form">
                      <div className="tax-setup-field-grid tax-setup-field-grid--fees">
                        <div className="tax-setup-field">
                          <label htmlFor="independent_tax_name" className="form-label">Tax Name*</label>
                          <Select
                            className="tax-setup-select"
                            classNamePrefix="tax-setup-select"
                            value={selectedOption(TaxNameOptions, independentTaxName)}
                            inputId="independent_tax_name"
                            name="independent_tax_name"
                            options={TaxNameOptions}
                            onChange={handleInputChangeIndependentTaxName}
                            isDisabled={updateClicked1}
                            placeholder="Select Tax Name"
                          />
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="independent_period" className="form-label">Per Day / Per Rental*</label>
                          <Select
                            className="tax-setup-select"
                            classNamePrefix="tax-setup-select"
                            value={selectedOption(RENTAL_PERIOD_OPTIONS, independentType)}
                            inputId="independent_period"
                            name="independent_period"
                            options={RENTAL_PERIOD_OPTIONS}
                            onChange={(option) => setIndependentType(option?.value || '')}
                            placeholder="Select one"
                          />
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="independent_currency" className="form-label">Currency*</label>
                          <input
                            type="text"
                            className="form-control"
                            value={independentCurrency}
                            id="independent_currency"
                            disabled
                          />
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="independent_amount" className="form-label">Amount*</label>
                          <input
                            type="text"
                            inputMode="decimal"
                            className="form-control"
                            value={independentAmount}
                            onChange={(e) => setIndependentAmount(e.target.value)}
                            id="independent_amount"
                          />
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="independent_applies_on" className="form-label">Applies On*</label>
                          <Select
                            className="tax-setup-select"
                            classNamePrefix="tax-setup-select"
                            value={selectedOption(APPLIES_ON_OPTIONS, independentApplisOn)}
                            inputId="independent_applies_on"
                            name="independent_applies_on"
                            options={APPLIES_ON_OPTIONS}
                            onChange={(option) => setIndependentAppliesOn(option?.value || '')}
                            placeholder="Select one"
                          />
                        </div>
                      </div>

                      <div className="tax-setup-modal-actions">
                          {
                            updateClicked1 ? (
                              <button type="button" className="btn btn-success" onClick={(e) => handleUpdateDB1(e)}>
                                Update
                              </button>
                            ) :
                              (
                                <button type="button" className="btn btn-success" onClick={(e) => handleSubmit1(e)}>
                                  Save
                                </button>
                              )
                          }
                      </div>
                    </form>


                  </Modal.Body>
                </Modal>



              </div>
            </div>

            {/* existing Tax table 2 starts */}
            <div className="row pt-5" id="tax-setup-state-section">
              <div className="col-md-12 tax-setup-section-card">
                <h5 className=" mb-3">State Tax</h5>

                <div className="tax-setup-table-region" role="region" aria-label="State taxes" tabIndex="0">
                <table className={`table tax-setup-data-table tax-setup-data-table--state ${accessType === 'View' ? '' : 'tax-setup-data-table--editable'}`}>
                  <thead>
                    <tr>
                      <th scope="col">Tax Name</th>
                      <th scope="col">Per Rental</th>
                      <th scope="col">Percentage (%)</th>
                      <th scope="col">Applies On</th>
                      <th scope="col">Last Updated By</th>
                      <th scope="col">Last Updated Date</th>
                      {!(accessType === "View") &&
                        <>
                          <th scope="col">Edit</th>
                          <th scope="col">Delete</th>
                        </>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {baseRateTaxDetail.length > 0 ? baseRateTaxDetail.map((val) => (
                      <tr key={val._id}>
                        <td>{val.tax_name}</td>
                        <td>{val.per_day_per_rental}</td>
                        <td>{val.percentage}</td>
                        <td>{val.applies_on}</td>
                        <td>{val.updated_by}</td>
                        <td>{formatDate_withTime(new Date(val.updated_date))}</td>
                        {
                          !(accessType === "View") &&
                          <>
                            <td>
                              <button
                                type="button"
                                className="tax-setup-icon-button"
                                onClick={() => handleUpdate2(val)}
                                aria-label={`Edit ${val.tax_name}`}
                                title="Edit tax"
                              >
                                <EditIcon fontSize="small" />
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="tax-setup-icon-button tax-setup-icon-button--danger"
                                onClick={() => handleDelete2(val._id)}
                                aria-label={`Delete ${val.tax_name}`}
                                title="Delete tax"
                              >
                                <DeleteForeverIcon fontSize="small" />
                              </button>
                            </td>

                          </>
                        }
                      </tr>
                    ))

                      : (
                        <tr>
                          <td colSpan="8">No tax present for selected location</td>
                        </tr>
                      )}


                  </tbody>
                </table>
                </div>
                {!(accessType === "View") && <button type="button" className="btn btn-success" onClick={() => setLgShow2(true)} >
                  Add New
                </button>}
                <Modal
                  size="lg"
                  show={lgShow2}
                  onHide={() => setLgShow2(false)}
                  aria-labelledby="state-tax-modal-title"
                  dialogClassName="tax-setup-modal"
                >
                  <Modal.Header closeButton >
                    <Modal.Title id="state-tax-modal-title" >
                      State Tax
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    <form className="tax-setup-modal-form">
                      <div className="tax-setup-field-grid">
                        <div className="tax-setup-field">
                          <label htmlFor="base_rate_tax_name" className="form-label">Tax Name*</label>
                          <Select
                            className="tax-setup-select"
                            classNamePrefix="tax-setup-select"
                            value={selectedOption(TaxNameOptions, baseRateTaxName)}
                            inputId="base_rate_tax_name"
                            name="base_rate_tax_name"
                            options={TaxNameOptions}
                            onChange={handleInputChangeBaseRateTaxName}
                            isDisabled={updateClicked2}
                            placeholder="Select Tax Name"
                          />
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="base_rate_period" className="form-label">Per Rental*</label>
                          <input
                            type="text"
                            id="base_rate_period"
                            className="form-control"
                            value={baseRateType}
                            disabled
                          />
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="base_rate_percentage" className="form-label">Percentage (%)*</label>
                          <input
                            type="text"
                            inputMode="decimal"
                            className="form-control"
                            value={baseRatePercentage}
                            onChange={(e) => setBaseRatePercentage(e.target.value)}
                            id="base_rate_percentage"
                          />
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="base_rate_applies_on" className="form-label">Applies On*</label>
                          <Select
                            className="tax-setup-select"
                            classNamePrefix="tax-setup-select"
                            value={selectedOption(APPLIES_ON_OPTIONS, baseRateApplisOn)}
                            inputId="base_rate_applies_on"
                            name="base_rate_applies_on"
                            options={APPLIES_ON_OPTIONS}
                            onChange={(option) => setBaseRateAppliesOn(option?.value || '')}
                            placeholder="Select one"
                          />
                        </div>
                      </div>

                      <div className="tax-setup-modal-actions">
                          {
                            updateClicked2 ? (
                              <button type="button" className="btn btn-success" onClick={(e) => handleUpdateDB2(e)}>
                                Update
                              </button>
                            ) :
                              (
                                <button type="button" className="btn btn-success" onClick={(e) => handleSubmit2(e)}>
                                  Save
                                </button>
                              )
                          }
                      </div>
                    </form>


                  </Modal.Body>
                </Modal>



              </div>
            </div>

            {/* existing Tax table 3 starts */}
            <div className="row pt-5" id="tax-setup-compound-section">
              <div className="col-md-12 tax-setup-section-card">
                <h5 className=" mb-3">Compound Tax</h5>

                <div className="tax-setup-table-region" role="region" aria-label="Compound taxes" tabIndex="0">
                <table className={`table tax-setup-data-table tax-setup-data-table--compound ${accessType === 'View' ? '' : 'tax-setup-data-table--editable'}`}>
                  <thead>
                    <tr>
                      <th scope="col">Tax Name</th>
                      <th scope="col">Percentage (%)</th>
                      <th scope="col">Applies on Sum Of	</th>
                      <th scope="col">Applies On</th>
                      <th scope="col">Last Updated By</th>
                      <th scope="col">Last Updated Date</th>
                      {!(accessType === "View") &&
                        <>
                          <th scope="col">Edit</th>
                          <th scope="col">Delete</th>
                        </>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    {calculatedTaxDetail.length > 0 ? calculatedTaxDetail.map((val) => (
                      <tr key={val._id}>
                        <td>{val.tax_name}</td>
                        <td>{val.percentage}</td>
                        <td>{appliedTaxSummary(val.applied_taxes) || '—'}</td>
                        <td>{val.applies_on}</td>
                        <td>{val.updated_by}</td>
                        <td>{formatDate_withTime(new Date(val.updated_date))}</td>
                        {
                          !(accessType === "View") &&
                          <>
                            <td>
                              <button
                                type="button"
                                className="tax-setup-icon-button"
                                onClick={() => handleUpdate3(val)}
                                aria-label={`Edit ${val.tax_name}`}
                                title="Edit tax"
                              >
                                <EditIcon fontSize="small" />
                              </button>
                            </td>
                            <td>
                              <button
                                type="button"
                                className="tax-setup-icon-button tax-setup-icon-button--danger"
                                onClick={() => handleDelete3(val._id)}
                                aria-label={`Delete ${val.tax_name}`}
                                title="Delete tax"
                              >
                                <DeleteForeverIcon fontSize="small" />
                              </button>
                            </td>

                          </>
                        }
                      </tr>
                    ))

                      : (
                        <tr>
                          <td colSpan="8">No tax present for selected location</td>
                        </tr>
                      )}


                  </tbody>
                </table>
                </div>
                {!(accessType === "View") && <button type="button" className="btn btn-success" onClick={() => setLgShow3(true)} >
                  Add New
                </button>}
                <Modal
                  size="lg"
                  show={lgShow3}
                  onHide={() => setLgShow3(false)}
                  aria-labelledby="compound-tax-modal-title"
                  dialogClassName="tax-setup-modal"
                >
                  <Modal.Header closeButton >
                    <Modal.Title id="compound-tax-modal-title" >
                      Compound Tax
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>

                    <form className="tax-setup-modal-form">
                      <div className="tax-setup-field-grid tax-setup-field-grid--compound">
                        <div className="tax-setup-field">
                          <label htmlFor="compound_tax_name" className="form-label">Tax Name*</label>
                          <Select
                            className="tax-setup-select"
                            classNamePrefix="tax-setup-select"
                            value={selectedOption(TaxNameOptions, calculatedTaxName)}
                            inputId="compound_tax_name"
                            name="compound_tax_name"
                            options={TaxNameOptions}
                            onChange={handleInputChangeCalculatedTaxName}
                            isDisabled={updateClicked3}
                            placeholder="Select Tax Name"
                          />
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="compound_percentage" className="form-label">Percentage (%)*</label>
                          <input
                            type="text"
                            inputMode="decimal"
                            className="form-control"
                            id="compound_percentage"
                            value={calculatedPercentage}
                            onChange={(e) => setCalculatedPercentage(e.target.value)}
                          />
                        </div>

                        <div className="tax-setup-field tax-setup-field--sum">
                          <label htmlFor="compound_applied_taxes" className="form-label">Applies On Sum Of*</label>
                          <Select
                            className="tax-setup-select tax-setup-select--multi"
                            classNamePrefix="tax-setup-select"
                            inputId="compound_applied_taxes"
                            name="compound_applied_taxes"
                            options={allTaxesData}
                            value={normalizeAppliedTaxOptions(selected)}
                            onChange={(options) => setSelected(options || [])}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            placeholder="Select base rate and taxes"
                            noOptionsMessage={() => 'No taxes available'}
                          />
                          <small className="tax-setup-field-hint">
                            Choose every amount included in this compound tax.
                          </small>
                        </div>

                        <div className="tax-setup-field">
                          <label htmlFor="compound_applies_on" className="form-label">Applies On*</label>
                          <Select
                            className="tax-setup-select"
                            classNamePrefix="tax-setup-select"
                            value={selectedOption(APPLIES_ON_OPTIONS, calculatedApplisOn)}
                            inputId="compound_applies_on"
                            name="compound_applies_on"
                            options={APPLIES_ON_OPTIONS}
                            onChange={(option) => setCalculatedAppliesOn(option?.value || '')}
                            placeholder="Select one"
                          />
                        </div>
                      </div>

                      <div className="tax-setup-modal-actions">
                          {
                            updateClicked3 ? (
                              <button type="button" className="btn btn-success" onClick={(e) => handleUpdateDB3(e)}>
                                Update
                              </button>
                            ) :
                              (
                                <button type="button" className="btn btn-success" onClick={(e) => handleSubmit3(e)}>
                                  Save
                                </button>
                              )
                          }
                      </div>
                    </form>


                  </Modal.Body>
                </Modal>



              </div>
            </div>
          </>) : ""}


          <div className="col-md-10 mb-4 ">

          </div>

        </div>

      </div>
    </div>
  );
}
